/**
 * Schema of Auditoria
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {$, datetime} from 'simpli-web-sdk'
import Auditoria from '@/model/resource/Auditoria'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import * as Helpers from '@/helpers'

export default (model: Auditoria): Schema => ({
  idAuditoriaPk: {
    content: model.idAuditoriaPk,
    hidden: true,
    editable: false,
  },

  conforme: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('conforme'),
          value: model.conformeTranslated,
          tagClass: model.conformeTagClass,
        },
      },
    ],
    input: InputType.CHECKBOX,
  },

  replicarCTE: {
    content: [],
    input: InputType.CHECKBOX,
  },

  motivo: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('motivo'),
          value: !model.conforme && model.motivo && model.motivo.$tag || '',
          tagClass: 'basic danger',
        },
      },
    ],
    input: InputType.SELECT,
  },

  responsavel: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('responsavel'),
          value: model.responsavel.$tag,
        },
      },
    ],
  },

  dataCanhoto: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('dataCanhoto'),
          value: datetime(model.dataCanhoto),
        },
      },
    ],
    input: InputType.DATETIME,
  },

  dataCriacao: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('dataCriacao'),
          value: datetime(model.dataCriacao),
        },
      },
    ],
    input: InputType.DATETIME,
    meta: {
      required: true,
    },
  },
})
